import FontBody1 from '../../../../../components/fonts/font-body1/font-body1';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../components/fonts/font-props';
import Card from '../../../../../components/layouts/card/card';
import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../components/form-field-line/form-field-line';
import currentAccountStore from "../../../../accounts/stores/current-account-store";
import currentPortalStore from "../../../../../stores/current-portal-store";
import { RadioButton } from "../../../../../components/inputs/radio-button/radio-button";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import edgePortalPreview from "../../../../../images/previews/portal-style/edge-portal-preview.png";
import classicPortalPreview from "../../../../../images/previews/portal-style/classic-portal-preview.png";
import { useState } from "react";
import "./portal-layout-style-card.scss";
import { ConfirmModal } from '../../../../../components/modal/components/confirm-modal/confirm-modal';
import customizationStore from '../../../../../stores/customizations/customization-store';

const PortalLayoutStyleCard: React.FC = observer(() => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const storeSetting = currentPortalStore.setting;

    if (!currentAccountStore.isSysAdmin) {
        return null;
    }

    const onPortalChange = () => {
        if (!customizationStore.hasChanges()) {
            storeSetting?.setEnablePortalV2(!storeSetting?.enablePortalV2);
            return;
        }
        setShowConfirmationModal(true);
    }

    return (
        <>
        <Card
            toolbar={{
                title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    Portal layout style
                </FontBody1>
            }}
            isExpanded={isExpanded}
            expandCallback={setIsExpanded}
        >
            <FormFieldLine
                label="Select your preferred portal style"
                note="Please select the style of the portal that you would like to use"
            >
                <div className="portal-layout-style-grid">
                    <div
                        className="portal-layout-style-option-container"
                        onClick={onPortalChange}
                    >
                        <div className="portal-layout-style-option-radio-container">
                            <div>
                                <RadioButton
                                    name={"enable_portal_v2"}
                                    checked={storeSetting?.enablePortalV2}
                                />
                            </div>
                            <div className="portal-layout-style-option-label-container">
                                <FontBody2 color={FONT_COLOR.PRIMARY2}>Edge</FontBody2>
                                <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                                    A visually-rich, responsive return experience
                                    designed for modern aesthetics across all devices.
                                </FontBody2>
                            </div>
                        </div>

                        <img src={edgePortalPreview} alt="Edge Portal Preview"/>
                    </div>

                    <div
                        className="portal-layout-style-option-container"
                        onClick={onPortalChange}
                    >
                        <div className="portal-layout-style-option-radio-container">
                            <div>
                                <RadioButton
                                    name={"enable_portal_v2"}
                                    checked={!storeSetting?.enablePortalV2}
                                />
                            </div>
                            <div className="portal-layout-style-option-label-container">
                                <FontBody2 color={FONT_COLOR.PRIMARY2}>Classic</FontBody2>
                                <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                                    A robust solution that handles complex return scenarios and promotional items with
                                    proven reliability.
                                </FontBody2>
                            </div>
                        </div>

                        <img src={classicPortalPreview} alt="Classic Portal Preview"/>
                    </div>
                </div>
            </FormFieldLine>
        </Card>
        {showConfirmationModal && <ConfirmModal
                cancelButton={{
                    title: "Cancel",
                    onClick: () => setShowConfirmationModal(false),
                }}
                okButton={{
                    title: "Discard",
                    onClick: () => {
                        setShowConfirmationModal(false);
                        storeSetting?.setEnablePortalV2(!storeSetting?.enablePortalV2);

                        customizationStore.discardChanges();
                    },
                }}
            />}
        </>

    )
})

export default PortalLayoutStyleCard
